const GymProfileSkeletonLoader = () => {
    return (
        <div className="w-full bg-gradient-radial flex flex-col animate-pulse">
            {/* Banner Section */}
            <section className="w-full bg-gradient-radial lg:pt-20 pt-20 pb-2 md:pb-12 lg:py-14">
                <div className="w-full lg:w-full flex flex-col items-center px-6 md:px-14 py-12">
                    <div className="relative w-full h-44 flex flex-col items-center md:h-96 rounded-lg shadow-lg">
                        {/* Background Image Placeholder */}
                        <div className="w-full h-full bg-gray-700 rounded-lg border border-gray-500" />

                        {/* Logo Box Placeholder */}
                        <div className="absolute flex justify-center items-end bottom-[-3rem] md:bottom-[-4rem]">
                            <div className="w-44 md:w-56 bg-gray-800 rounded-xl rounded-tr-[0.4rem] shadow-md border-[3px] border-white flex items-center justify-center z-10">
                                <div className="h-24 md:h-32 w-full bg-gray-700 rounded-md" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Header Section */}
            <section className="w-full bg-gradient-radial py-5 px-8 md:px-20">
                <div className="flex flex-col md:flex-row items-start md:items-center py-4 w-full gap-4">
                    <div className="relative w-full flex flex-col items-start gap-3">
                        <div className="h-6 w-64 bg-gray-700 rounded-md" /> {/* Title */}
                        <div className="flex flex-row items-start gap-2">
                            <div className="h-6 w-6 bg-gray-700 rounded-full" /> {/* Location icon */}
                            <div className="h-4 w-80 bg-gray-700 rounded-md" /> {/* Address */}
                        </div>
                    </div>
                    <div className="h-4 w-20 bg-gray-700 rounded-md md:ml-8" /> {/* Navigate button */}
                </div>
            </section>
        </div>

    )
}

export { GymProfileSkeletonLoader };
